exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".data-profile {\n  margin-bottom: 0em !important;\n  display: -ms-flexbox;\n  display: flex; }\n  .data-profile > div {\n    min-width: 150px; }\n\n.label-status {\n  margin-left: 1rem;\n  background: #18ba62;\n  color: #ffffff;\n  font-size: 12px; }\n\n.data-profile-btn-orange {\n  background: #e69716;\n  color: #eff3f6;\n  font-size: 14px;\n  font-weight: 900;\n  margin-right: 7px; }\n\n.data-profile-btn-red {\n  background: #d0021b;\n  color: #eff3f6;\n  font-size: 14px;\n  font-weight: 900; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/pages/user/profile-detail/profile-detail.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./src/pages/user/profile-detail/profile-detail.css
// module chunks = 0